// @flow

const getConfiguration = (props: any) => {
    return {
        enableRowExtension: true,
    }
}
export default getConfiguration;